module.exports = __webpack_public_path__ + "images/tidings-bom-imag-new.1787648603550.png";